export default "__VITE_ASSET__4886d04e__"